import { Observable } from 'rxjs';
import { Action } from 'redux-actions';
import api from '@src/api';

export const getOutingPunchSetting = (): Observable<Action> => (
	api.get('punch-in-records/field-records/setting')
);

type BaseOutingPunch = {
	duty: boolean,
	attachment_ids: string[],
  shift_id?: string
	reason: string,
}

type LocationOutingPunch = BaseOutingPunch & {
	punch_in_type: 'location',
	location_id: string,
	latitude: number,
	longitude: number,

}

type IPPostOutingPunch = BaseOutingPunch & {
  punch_in_type: 'ip'
  ip_setting_id: string,
}

export type IPostOutingPunch = LocationOutingPunch | IPPostOutingPunch;
export const postOutingPunch = (props: IPostOutingPunch): Observable<Action> => (
	api.post('punch-in-records/field-records', props)
);
